import { ExistResponse, ListResponse } from './common';
import { ky } from './ky';
import { FileDto } from './file';

export interface AccountDto {
  /**
   * 계정 ID (판매자 콘솔 등에서 sellerAccountId로 사용)
   */
  id?: number;

  /**
   * 계정 유형 (PERSONAL | BUSINESS). 브랜드 판매자 콘솔 접근 판별에 사용한다.
   */
  accountType?: string;

  /**
   * 계정 이름
   */
  name: string;

  /**
   * 계정 별칭
   */
  nickname: string;

  /**
   * 캡션
   */
  caption?: string;

  /**
   * 팔로워 수
   */
  followerCount?: number;

  /**
   * 팔로잉 수
   */
  followingCount?: number;

  /**
   * 프로필 이미지
   */
  profile?: FileDto | null;

  /**
   * 게시물 수
   */
  feedCount?: number;

  /**
   * 팔로잉 중인지 여부
   */
  isFollowing?: boolean;
}

export default class AccountService {

  async get(accountName: string): Promise<AccountDto> {
    return await ky.get(`v1/accounts/${accountName}`, {
      cache: 'no-cache'
    }).json() as AccountDto;
  }

  async create(body: AccountDto): Promise<AccountDto> {
    return await ky.post('v1/accounts', { json: body });
  }

  async update(body: AccountDto): Promise<AccountDto> {
    return await ky.put(`v1/accounts/${body.name}`, { json: body });
  }

  async getFollowers(accountName: string, lastName?: string) {
    return await ky.get(`v1/accounts/${accountName}/followers${lastName ? `?lastName=${lastName}` : ''}`, {}).json() as ListResponse<AccountDto>;
  }


  async getFollowing(accountName: string, lastName?: string) {
    return await ky.get(`v1/accounts/${accountName}/following${lastName ? `?lastName=${lastName}` : ''}`, {}).json() as ListResponse<AccountDto>;
  }

  async follow(accountName: string) {
    return await ky.post(`v1/accounts/${accountName}/follow`);
  }

  async unFollow(accountName: string) {
    return await ky.delete(`v1/accounts/${accountName}/follow`);
  }

  async block(accountName: string, targetAccountName: string) {
    return await ky.post(`v1/accounts/${accountName}/blocks/${targetAccountName}`);
  }

  async unblock(accountName: string, targetAccountName: string) {
    return await ky.delete(`v1/accounts/${accountName}/blocks/${targetAccountName}`);
  }

  async getBlocks(accountName: string) {
    return await ky.get(`v1/accounts/${accountName}/blocks`).json() as AccountDto[];
  }
}
